import _ from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { getNumericDeclension } from '@culture/common-helpers/string';

import GradientCard from 'components/cards/GradientCard';
import OffsetSlider from 'components/sliders/OffsetSlider';
import Section from 'components/Section';

import { visitCatalogCardsData } from 'utils/helpers/landings';

const Catalogs = ({ counters, subtitle }) => {
	const cardsDataWithCounters = useMemo(
		() =>
			_(visitCatalogCardsData).reduce(
				(memo, { wordVariants, catalog, ...rest }) => {
					const counter = counters[catalog];

					if (counter) {
						const subTitle = getNumericDeclension(counter, wordVariants);

						memo.push({ ...rest, counter, subTitle });
					}

					return memo;
				},
				[]
			),
		[counters]
	);

	const themes = ['primary', 'secondary', 'tertiary', 'quaternary'];

	return (
		<Section
			title="Культурные места"
			align="center"
			titleSize="medium"
			subtitle={subtitle}
		>
			<OffsetSlider>
				{_(cardsDataWithCounters).map(
					({ counter, subTitle, title, icon, url }, index) => (
						<GradientCard
							key={url}
							largeTitle={`${counter}`}
							title={subTitle}
							icon={icon}
							subtitle={title}
							theme={themes[index % 4]}
							url={url}
						/>
					)
				)}
			</OffsetSlider>
		</Section>
	);
};

Catalogs.propTypes = {
	counters: PropTypes.object.isRequired,
	subtitle: PropTypes.string
};

export default Catalogs;
